import { render, staticRenderFns } from "./RegisterWizard.vue?vue&type=template&id=37aa322a&"
import script from "./RegisterWizard.vue?vue&type=script&lang=js&"
export * from "./RegisterWizard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports